/* eslint-disable prettier/prettier */
import Backdrop from '@mui/material/Backdrop'
import CircularProgress from '@mui/material/CircularProgress'
import React from 'react'
import { useSelector } from 'react-redux'
import { TEXT } from '../theme/tokens'

// `loading` is derived from the write counter in appSlice: true while a
// write (POST, PUT, DELETE not marked background) is in flight, so a second
// click cannot repeat it. Reads show components/ReadProgress instead
// (services/axios/axiosConfig#blocksScreen).
const AppLoader = () => {
    const { loading } = useSelector((state) => state.app)
    return (
        <Backdrop
            sx={{
                color: TEXT.primary,
                zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={loading}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    )
}

export default AppLoader
